import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';

import { translate as t } from '../../lib/I18n';
import PassengersForm from '../../records/search/PassengersForm';

import SectionErrors from './SectionErrors';
import StepperInput from '../form/StepperInput';
import PureRenderComponent from '../PureRenderComponent';

class PassengersSelector extends PureRenderComponent {
    static propTypes = {
        adults: PropTypes.number.isRequired,
        children: PropTypes.number.isRequired,
        onAdultsChange: PropTypes.func.isRequired,
        onChildrenChange: PropTypes.func.isRequired,
        className: PropTypes.string,
        Form: PropTypes.func,
        hideInfo: PropTypes.bool,
        maxTickets: PropTypes.number,
    };

    static defaultProps = {
        className: '',
        Form: PassengersForm,
        hideInfo: false,
        maxTickets: -1,
    };

    render() {
        const {
            adults,
            children,
            className,
            hideInfo,
            onAdultsChange,
            onChildrenChange,
            maxTickets,
        } = this.props;
        const childText = t('booking.railcards.stepper.child', { children });
        const adultText = t('booking.railcards.stepper.adult', { adults });

        const form = new this.props.Form({
            adults,
            children,
        });
        const errors = form.getValidationSummary();
        const errorArray = form.getValidationSummaryArray();

        const maxAdults = maxTickets !== -1 ? maxTickets - children : 9;
        const maxChildren = maxTickets !== -1 ? maxTickets - adults : 9;

        console.log('DEBUG hideInfo', hideInfo);

        return (
            <div className={classnames(className)}>
                <div className="stepper-container">
                    <StepperInput
                        name="adults"
                        label={adultText}
                        value={adults}
                        onChange={onAdultsChange}
                        error={errors.adults || errors.total || null}
                        max={maxAdults}
                    />
                    <StepperInput
                        name="children"
                        label={childText}
                        value={children}
                        onChange={onChildrenChange}
                        error={errors.children || errors.total || null}
                        max={maxChildren}
                    />
                </div>
                {!hideInfo && (
                    <p className="text-sm text-light margin-top--sm">
                        {t('booking.passenger.child-fare.info')}
                    </p>
                )}

                {errorArray.length > 0 && <SectionErrors errors={errorArray} />}
            </div>
        );
    }
}

export default PassengersSelector;



// WEBPACK FOOTER //
// ./src/components/search/PassengersSelector.js